import { FC, useEffect } from 'react';

import * as S from './Overlay.styles';

interface OverlayProps {
  onClick?: () => void;
  top?: number;
  zIndex?: number;
}

export const Overlay: FC<OverlayProps> = ({
  onClick,
  top,
  zIndex,
  ...rest
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return <S.Overlay $zIndex={zIndex} $top={top} onClick={onClick} {...rest} />;
};
